import { AbstractFilterHandlerResultModel } from '../models/abstract-filter-handler-result-model'
import { FilterHandlerContext } from '../models/filter-handler-context'
import { RuleBaseFilterHandlerResultModel } from '../models/rule-base-filter-handler-result-model'
import { FundRuleName } from '../rules/fund-rule-name'
import { IFilterHandler } from '../rules/ifilter-handler'
import { IFundRule } from '../rules/ifund-rule'

export class AppliedRuleFinderCommonFilterHandler implements IFilterHandler {
  handleFilterSelection(
    filterName: FundRuleName,
    handlerContext: FilterHandlerContext,
  ): AbstractFilterHandlerResultModel {
    const rule: IFundRule = handlerContext.getRule(filterName)
    return new RuleBaseFilterHandlerResultModel(rule)
  }
}
